<div
  *ngIf="visible"
  class="prs-impersonation-banner prs-sales-account-banner prs-account-strip"
  data-testing-id="sales-rep-account-banner"
  role="status"
>
  <div class="prs-account-strip__main">
    <span class="prs-account-strip__label">{{ 'sales_rep.banner.label' | translate }}</span>
    <button
      type="button"
      class="prs-account-strip__account"
      data-testing-id="sales-rep-account-banner-switch"
      [disabled]="busy"
      (click)="openSwitch()"
    >
      <span class="prs-impersonation-banner__text">{{ accountLabel }}</span>
      <i class="bi bi-chevron-down prs-account-strip__chevron" aria-hidden="true"></i>
    </button>
  </div>
</div>

<custom-sales-rep-customer-switch-confirmation-modal
  #confirmationModal
  (confirmed)="onConfirmSwitch($event)"
  (cancelled)="onCancelSwitch()"
/>
